<template>
  <div class="announcementManagement-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button type="primary" size="small" @click="annouAction('add', {})">+新增跑马灯</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="title" label="标题" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.title || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="position" label="显示位置" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.position | positionRule}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="href" label="url" align="center" min-width="260">
        <template slot-scope="scope">
          <span>{{scope.row.href || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="内容" align="center" min-width="320" show-overflow-tooltip>
        <template slot-scope="scope">
          {{scope.row.content}}
        </template>
      </el-table-column>
      <el-table-column prop="sorted" label="排序" align="center" min-width="110">
        <template slot-scope="scope">
          {{scope.row.sorted}}
        </template>
      </el-table-column>
      <el-table-column prop="active" label="状态" align="center" min-width="110">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.active" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" min-width="240" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operating" label="操作" align="center" min-width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" class="el-icon-edit" @click="annouAction('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" class="el-icon-delete" @click="remove(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5, 15, 20, 30]" :current-page="annouParam.pageNumber" :page-size="annouParam.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 1" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑tag弹窗-->
    <annou-action ref="tagAction" @handlerAnnouList="getAnnouList('status')"></annou-action>
  </div>
</template>
<script>
import API from '@/api'
import AnnouAction from './components/annouAction'
import baseConfig from '@/utils/serverUrlConfig'

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      imgUrl: baseConfig.imgUrl,
      total: 0,
      // 公告列表请求参数
      annouParam: {
        pageNumber: 1,
        pageSize: 5,
        type:"3", // 跑马灯
        status:-1,
        ctype:-1,
      }
    }
  },
  components: {
    AnnouAction
  },
  filters: {
    typeRule: (value) => {
      if (value != 0 && !value) {
        return '未知'
      }
      let typeList = {
        1: '系统公告',
        2: '浮窗位置',
        3: '跑马灯',
        4: '评论公告',
      }
      return typeList[value] ? typeList[value] : '-'
    },
    positionRule: (value) => {
      if (value != 0 && !value) {
        return '未知'
      }
      let typeList = {
        0: '通用',
        1: '首页',
        2: '暗网',
        3: '社区',
        4: '抖阴',
        //5: '播放详情',
        //6: '帖子详情',
      }
      return typeList[value] ? typeList[value] : '-'
    },
  },
  created() {
    this.getAnnouList()
  },
  methods: {
    // 请求公告列表
    getAnnouList() {
      this.loading = true;
      API.getAnnouList(this.annouParam).then(res => {
        if (res.code === 200 && res.data.aInfos) {
          this.tableData = res.data.aInfos
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.annouParam.pageSize = size
      this.annouParam.pageNumber = 1
      this.getAnnouList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.annouParam.pageNumber = pageNumber
      this.getAnnouList()
    },
    // 删除tags
    remove(id) {
      this.$confirm('您确定要删除当前公告吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            ids: [id]
          }
          API.delAnnou(params).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getAnnouList('status')
            } else {
              this.$message.error('删除失败，请重试')
            }
          })
        })
    },
    // 新增、删除tags
    annouAction(type, data) {
      this.$refs.tagAction.open(type, data);
    }
  }
}
</script>
<style lang="scss">
.views {
  font-size: 20px;
  color: #e63765;
  cursor: pointer;
  &:hover {
    color: #eb5f84;
  }
}
.edit {
  font-size: 18px;
  cursor: pointer;
  color: #e63765;
  vertical-align: middle !important;
  &:hover {
    color: #eb5f84;
  }
}
.cell {
  overflow: hidden;
}
.tags {
  font-size: 12px;
  margin-right: 5px;
}
</style>
